/**
 * @file Allow using app feature flags
 */
import window from 'bits/global'

window.ww = window.ww || {}

const flip = window.ww.flip || {}

type CurrentFlags =
  | 'wishOrderArray'
  | 'debugFrontend'
  | 'newSettings'
  | 'goldPlansVisible'
  | 'contentPicker'
  | 'newPostEditModal'
  | 'brahmsRealtime'

function isAppUsing(feature: CurrentFlags, version?: null | number): boolean {
  if (version) {
    return flip[feature] >= version
  }
  return flip[feature] || false
}

export { isAppUsing }
